module.exports = __webpack_public_path__ + "static/pizzaIcon-6a6d87bdeef23b8f8dbec0a190b34d09.png";